import { Instance } from 'mobx-state-tree';
import CollectionArrayProcessor from '~/mst/models/abstract/collection_array_processor';
import model from './model';
import actions from './actions';
import views from './views';

const ThreadsStore = model.views(views).actions(actions);

export interface IThreadsStore extends Instance<typeof ThreadsStore> {}

export default CollectionArrayProcessor(ThreadsStore);
